export default function IconJobs({ color = '#1E293B', width = 17, height = 16, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.85294 4.4707H12.6961C13.1121 4.4707 13.5111 4.63597 13.8053 4.93014C14.0994 5.22432 14.2647 5.6233 14.2647 6.03933V6.82364L15.049 7.60796V9.9609L14.2647 10.7452V13.0982C14.2647 13.5142 14.0994 13.9132 13.8053 14.2073C13.5111 14.5015 13.1121 14.6668 12.6961 14.6668H4.85294C4.43692 14.6668 4.03793 14.5015 3.74375 14.2073C3.44958 13.9132 3.28431 13.5142 3.28431 13.0982V10.7452L2.5 9.9609V7.60796L3.28431 6.82364V6.03933C3.28431 5.6233 3.44958 5.22432 3.74375 4.93014C4.03793 4.63597 4.43692 4.4707 4.85294 4.4707V4.4707Z'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.20605 11.5293H10.3433'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.02985 8.39222C6.24643 8.39222 6.42201 8.21665 6.42201 8.00007C6.42201 7.78348 6.24643 7.60791 6.02985 7.60791C5.81327 7.60791 5.6377 7.78348 5.6377 8.00007C5.6377 8.21665 5.81327 8.39222 6.02985 8.39222Z'
        fill={color}
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.5201 8.39222C11.7367 8.39222 11.9122 8.21665 11.9122 8.00007C11.9122 7.78348 11.7367 7.60791 11.5201 7.60791C11.3035 7.60791 11.1279 7.78348 11.1279 8.00007C11.1279 8.21665 11.3035 8.39222 11.5201 8.39222Z'
        fill={color}
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.42201 4.47051L5.6377 1.33325'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.1279 4.47051L11.9122 1.33325'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
